// extracted by mini-css-extract-plugin
export default {"input":"VerificationCode_input__MvzBC","align-center":"VerificationCode_align-center__WlC0f","align-left":"VerificationCode_align-left__1DhZJ"};